import { createSlice } from "@reduxjs/toolkit";

export const contractSlice = createSlice({
  name: "contracts",
  initialState: {
    requestedYears: {
      all: [],
      contractor: [],
      supervisor: [],
      support: [],
      closed: [],
      // Contratos de personas jurídicas (colección contractsLegal): legal es
      // el listado del gestor; legalSupervisor, los del supervisor asignado
      // (secciones separadas porque las queries devuelven subconjuntos
      // distintos por usuario).
      legal: [],
      legalSupervisor: [],
      // Contratos de la empresa contratista (C5): los del entityNit del
      // usuario-empresa, otro subconjunto distinto por usuario.
      legalContractor: [],
    },
    contracts: {
      all: null,
      contractor: null,
      supervisor: null,
      support: null,
      closed: null,
      legal: null,
      legalSupervisor: null,
      legalContractor: null,
    }
  },
  reducers: {
    addContracts: (state, action) => {
      const { contracts, section } = action.payload;
      const existingContracts = state.contracts[section] || [];
      const existingCodes = new Set(existingContracts.map(c => c.contractCode));
      const newContracts = contracts.filter(c => !existingCodes.has(c.contractCode));
      state.contracts[section] = [...existingContracts, ...newContracts];
    },
    setYearToRequest: (state, action) => {
      const { year, section } = action.payload;
      if (!state.requestedYears[section].includes(year)) {
        state.requestedYears[section].push(year);
      }
    }
  }
});

// Action creators are generated for each case reducer function
export const { addContracts, setYearToRequest } = contractSlice.actions;

export default contractSlice.reducer;
